import APIClient from '@/shared/http/clients/api'

const resourceName = 'ZSistema'
const APIBusinessCommon = process.env.APIBaseURLBusinessCommon

const GetAllBills = (obraID, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/SPContasPagar?obraID=${obraID}`, data, config)
const GetAllPurchaseOrder = (obraID, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/SPOrdemCompra?obraID=${obraID}`, data, config)
const GetPurchaseOrderDetail = (companyID, order, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/SPOrdemCompraDetalhe/${companyID}?ordem=${order}`, data, config)
const GetPurchaseOrderItems = (companyID, order, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/SPOrdemCompraItens/${companyID}?ordem=${order}`, data, config)
const GetPurchaseOrderParcels = (companyID, order, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/SPOrdemCompraParcelas/${companyID}?ordem=${order}`, data, config)
const GetPurchaseOrderAttachments = (companyID, order, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/SPOrdemCompraAnexos/${companyID}?ordem=${order}`, data, config)
const PrintPurchaseOrder = (companyID, order, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/RelatorioOrdemCompra/${companyID}?ordem=${order}`, data, config)
const GetAllUF = (data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/ViewZUF`, data, config)
const GetAllCity = (uf, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/ViewZCidade/${uf}`, data, config)
const GetAllEvaluationOrder = (obraID, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/ViewComprasAvaliacaoPedidoResponsavel?obraID=${obraID}`, data, config)

const ZSystemRepository = {
  GetAllBills,
  GetAllPurchaseOrder,
  GetPurchaseOrderDetail,
  GetPurchaseOrderItems,
  GetPurchaseOrderParcels,
  GetPurchaseOrderAttachments,
  PrintPurchaseOrder,
  GetAllUF,
  GetAllCity,
  GetAllEvaluationOrder
}
export default ZSystemRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/zsystem.js